<template>
  <v-footer
    :fixed="fixed"
    app
    :class="[showMobileMenu ? 'transparent' : 'primary']"
    class="pa-0"
    dark
  >
    <v-bottom-navigation v-if="showMobileMenu" grow class="primary">
      <template v-for="(item, i) in links">
        <v-btn
          v-if="!item.hidden"
          :key="i"
          :to="item.path"
          exact
          v-bind="iconSize(item.title)"
        >
          <span>{{ $t(`pages.${item.title}`) }}</span>
          <v-icon class="mb-1" v-bind="iconSize(item.title)">
            fa-{{ item.icon }}
          </v-icon>
        </v-btn>
      </template>
    </v-bottom-navigation>
    <v-container v-else class="text-center">
      <v-row>
        <v-col cols="2" md="1">
          <v-fab-transition>
            <v-btn
              v-show="showScrollTop"
              light
              @click="$vuetify.goTo('body')"
              small
              bottom
              left
              fixed
              fab
            >
              <v-icon small>fa-angle-up</v-icon>
            </v-btn>
          </v-fab-transition>
        </v-col>
        <v-col cols="10" md="11">
          &copy; {{ new Date().getFullYear() }} - {{ title }}
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import { footer } from "@/mixins";

export default {
  mixins: [footer],
  data: () => ({
    showScrollTop: false,
  }),
  mounted() {
    window.addEventListener("scroll", () => {
      this.showScrollTop = window.pageYOffset > window.innerHeight;
    });
  },
  methods: {
    iconSize(title) {
      if (this.$route.name === this.lowerCase(title)) {
        return { medium: true };
      } else {
        return { small: true };
      }
    },
  },
};
</script>
